module.exports = __webpack_public_path__ + "img/zhiwu_2.d93ee051.png";